export const STORE_GLOBAL_CODES = "STORE_GLOBAL_CODES";
export const STORE_BOOK_DETAIL = "STORE_BOOK_DETAIL";
export const STORE_TAGS = "STORE_TAGS";

